import script from "./ApprovalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalDetail.vue?vue&type=style&index=0&id=374cce82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374cce82"]])

export default __exports__